<!--- Formulario FrmExpedition ---->
<!---
Descripción del componente y comportamiento:
---------------------------
-

Eventos escuchados por el formulario:
-----------------------

Eventos generados por el formulario:
-----------------------
-  XXXXXXX ->
--->

<template>
  <f7-page
    class="main-frmexpedition main-scan"
    name="scan"
  >
    <template #fixed>
      <TheNavbar
        class="navbar-frmexpedition"
        :nav-title="userEnviroment.EntornoDeTrabajo.Centro?.Nombre ?? $t('commercialization.common.expeditions')"
        :back-btn-enable="true"
        :back-callback="BackToMain"
        :style="appTheme"
        add-btn-enable
        @add-btn="OpenNewExpedition"
      >
        <template #right>
          <div class="display-flex">
            <f7-link @click="RefreshMainData">
              <img
                :src="icRefreshBlue"
                width="38px"
                height="38px"
              >
            </f7-link>

            <f7-link @click="EventOpenReadAns">
              <img
                :src="icQr"
                width="38px"
                height="38px"
              >
            </f7-link>
          </div>
        </template>
      </TheNavbar>
    </template>

    <div class="padding-half bloque-busqueda">
      <div class="container-filtros">
        <UCSearchEmpty
          ref="PCBuscador"
          class="input-searcher"
          @focus="Valor"
        />
        <UCDatePicker
          id="date-filter"
          ref="datepicker"
          class="input-date"
          :disabled="disableDatePicker"
          :new-date="newDateDatePicker"
          @onchange="ChangedDateFilter"
        />
      </div>

      <div class="bloque-busqueda__texto margin-top-half">
        <img src="@/static/icons/ic_help.svg">
        <span>
          {{ $t('commercialization.info.youCanSearchByClientNumberOrderPlate') }}
        </span>
      </div>
    </div>

    <div
      v-if="showNoExpeditions"
      class="bloque-no-expeditions"
    >
      <img
        src="@/static/icons/ic_base.svg"
        class="bloque-no-expeditions__img"
      >

      <div class="bloque-no-expeditions__text">
        {{ $t('commercialization.info.thereAreNoExpeditions') }}
      </div>

      <div class="bloque-no-expeditions__text2">
        {{ $t('common.pleasePress') }}<img
          class="bloque-no-expeditions__img2"
          src="@/static/icons/base.svg"
        >{{ $t('commercialization.info.toAddANewExpedition') }}
      </div>
    </div>
    <div class="content-accordion">
      <UCAcordeon
        ref="UCAcordeon"
        :items="elementFilter"
        title-option="NombreAgrupacion"
        badge-text-color="var(--his-oliva)"
        :opened-index="itemAcordeonOpen"
        :closed="true"
        :after-title="false"
        @click-element-event="EventSelectedElemenParentAcordeon"
      >
        <template #subOption="{ item }">
          <f7-list-item
            link="#"
            :text="`${item.Producto != null ? item.Producto.Nombre : ''}`"
            :footer="`${item.Envase?.Nombre ?? ''} ${item.Envase && item.Marca ? '|' : ''}  ${item.Marca?.Nombre ?? ''}`"
            @click="NavigateToExpeditionDocument(item)"
          >
            <template #subtitle>
              <div>
                <div>{{ item.Cliente != null ? item.Cliente.Nombre : '' }}</div>
                <div>
                  {{
                    `${item.Expedicion.Matricula} - ${showAddressName
                      ? item.Direccion != null
                        ? `${item.Direccion.Nombre} - ${item.Direccion.Direccion}`
                        : $t('commercialization.common.noAddress')
                      : item.Direccion != null
                        ? item.Direccion.Direccion
                        : $t('commercialization.common.noAddress')}`
                  }}
                </div>
              </div>
            </template>

            <template #title>
              <div v-if="item.Expedicion !== null">
                <div
                  v-if="item.Expedicion.FechaSalida !== null"
                  class="item-title__date"
                >
                  {{ FormatDate(item.Expedicion.FechaSalida, 'HH:mm') }}
                </div>
                <div
                  v-if="item.LineaPedidoVenta != null && item.LineaPedidoVenta.PedidoVenta != null"
                  class="item-title__info"
                >
                  {{
                    `${item.Expedicion.Serie}/${item.Expedicion.Numero} - ${item.LineaPedidoVenta.PedidoVenta.Serie
                    }/${
                      item.LineaPedidoVenta.PedidoVenta.Numero
                    }-${
                      item.LineaPedidoVenta.Orden}`
                  }}
                </div>
                <div
                  v-else
                  class="item-title__info"
                >
                  {{ `${item.Expedicion.Serie}/${item.Expedicion.Numero} -  ` }}
                </div>
              </div>
            </template>

            <template #after>
              <div
                class="item-after-info"
                :class="GetItemAfterClassByQuantity(item)"
              >
                {{ `${item.CantidadTotalCargada} ${$t('common.of')} ${item.CantidadTotalPales}` }}
              </div>
            </template>
          </f7-list-item>
        </template>
      </UCAcordeon>
    </div>
    <!-- <UCPreload :show="showPreload" /> -->
    <f7-panel
      right
      resizable
      :opened="panelDerecho"
      class="panel-container"
      @panel:closed="panelDerecho = false"
    >
      <f7-view>
        <f7-page>
          <div class="container-filters">
            <div class="container-filters__header padding-half">
              <div class="container-filters__header--title">
                <img src="@/static/icons/ic_filter.svg">{{ $t('common.filter') }}
              </div>
              <div class="container-filters__header--buttons">
                <img
                  class="margin-right-half"
                  src="@/static/icons/ic_info.svg"
                  width="28"
                  height="28"
                >
                <img
                  src="@/static/icons/ic_close_blue_2.svg"
                  width="28"
                  height="28"
                  @click="panelDerecho = false"
                >
              </div>
            </div>
            <div class="padding-horizontal-half margin-top-half">
              <div class="container-filters__client">
                <UCSearchEntityERP
                  ref="UCClientComponent"
                  :title="$t('common.customer')"
                  :placeholder="$t('common.customer')"
                  :search-text="$t('searchEntity.client.searchText')"
                  :search-cancellation-text="$t('searchEntity.client.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.client.searchNotFoundText')"
                  :end-point-for-code-search="GetCustomersByCode"
                  :end-point-for-list="GetCustomers"
                  :property-entity-shown-input="['Codigo', 'Sujeto.NombreCompleto']"
                  :property-entity-shown-list-title="['Sujeto.NombreCompleto']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventClientSelected"
                />
              </div>
              <div class="container-filters__order">
                <UCSearchEntityERP
                  ref="UCOrderComponent"
                  :title="$t('searchEntity.order.title.searchByOrder')"
                  :placeholder="$t('searchEntity.order.placeholder.searchByOrder')"
                  :search-text="$t('searchEntity.order.searchText')"
                  :search-cancellation-text="$t('searchEntity.order.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.order.searchNotFoundText')"
                  :end-point-for-list="GetSalesOrder"
                  :end-point-for-code-search="GetSalesOrderByFilter"
                  :property-entity-shown-input="[
                    'LineaPedidoVenta.PedidoVenta.Serie',
                    'LineaPedidoVenta.PedidoVenta.Numero',
                    'LineaPedidoVenta.Orden',
                  ]"
                  :property-entity-shown-list-title="[
                    'LineaPedidoVenta.PedidoVenta.Serie',
                    'LineaPedidoVenta.PedidoVenta.Numero',
                    'LineaPedidoVenta.Orden',
                  ]"
                  :property-entity-shown-list-subtitle="[
                    'LineaPedidoVenta.PedidoVenta.Cliente.Nombre',
                    'LineaPedidoVenta.InfoProducto.Nombre',
                    'LineaPedidoVenta.PedidoVenta.FechaSalida',
                    'LineaPedidoVenta.PedidoVenta.Referencia',
                    'LineaPedidoVenta.PedidoVenta.NombreTransportista',
                  ]"
                  :pre-property-entity-shown-list-subtitle="[
                    `${$t('common.customer')}: `,
                    `${$t('common.product')}: `,
                    `${$t('common.departureDateShort')}: `,
                    `${$t('common.reference')}: `,
                    `${$t('common.carrier')}: `,
                  ]"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :search-in="['.item-title', '.subtitle0', '.subtitle1', '.subtitle2', '.subtitle3', '.subtitle4']"
                  @selection="EventOrderSelected"
                >
                  <template #subtitle-2="{ item }">
                    <div class="div_Fecha-Ref">
                      {{ `${$t('common.departureDateShort')}:` }} <span class="span_Fecha-Ref"> {{ FormatDate(item, 'DD/MM/YYYY') }}</span>
                    </div>
                  </template>
                  <template #subtitle-3="{ item }">
                    <div class="div_Fecha-Ref">
                      {{ `${$t('common.reference')}:` }} <span class="span_Fecha-Ref">{{ item }}</span> {{ item }}
                    </div>
                  </template>
                  <template #subtitle-4="{ item }">
                    <div class="div_Fecha-Ref">
                      {{ `${$t('common.carrier')}:` }} <span class="span_Fecha-Ref">{{ item }}</span> {{ item }}
                    </div>
                  </template>
                </UCSearchEntityERP>
              </div>
              <div class="container-filters__articles">
                <UCSearchEntityERP
                  ref="UCArticlesComponent"
                  :title="$t('searchEntity.article.title.searchByArticles')"
                  :placeholder="$t('searchEntity.article.placeholder.searchByArticles')"
                  :search-text="$t('searchEntity.article.searchText')"
                  :search-cancellation-text="$t('searchEntity.article.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.article.searchNotFoundText')"
                  :end-point-for-code-search="GetArticlesByCode"
                  :end-point-for-list="GetArticles"
                  :property-entity-shown-input="['Codigo', 'Nombre']"
                  :property-entity-shown-list-title="['Codigo']"
                  :property-entity-shown-list-subtitle="['Nombre']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventArticlesSelected"
                />
              </div>
              <div class="container-filters__tuition">
                <UCSearchEntityERP
                  ref="UCTuitionComponent"
                  :title="$t('common.registration')"
                  :placeholder="$t('searchEntity.plate.placeholder.searchByPlate')"
                  :search-text="$t('searchEntity.plate.searchText')"
                  :search-cancellation-text="$t('searchEntity.plate.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.plate.searchNotFoundText')"
                  :end-point-for-code-search="GetPlatesByCode"
                  :end-point-for-list="GetPlates"
                  :property-entity-shown-input="['Matricula', 'Descripcion']"
                  :property-entity-shown-list-title="['Matricula']"
                  :property-entity-shown-list-subtitle="['Descripcion']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventTuitionSelected"
                />
              </div>
              <div class="container-filters__num-order">
                <UCSearchEntityERP
                  ref="UCNumOrderComponent"
                  :title="$t('searchEntity.expeditionNumber.title.expeditionNumber')"
                  :placeholder="$t('searchEntity.expeditionNumber.placeholder.expeditionSerialOrNumber')"
                  :search-text="$t('searchEntity.expeditionNumber.searchText')"
                  :search-cancellation-text="$t('searchEntity.expeditionNumber.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.expeditionNumber.searchNotFoundText')"
                  :end-point-for-code-search="GetExpeditionByCode"
                  :end-point-for-list="GetOrder"
                  :property-entity-shown-input="['Serie', 'Numero']"
                  :property-entity-shown-list-title="['Serie', 'Numero']"
                  :property-entity-shown-list-subtitle="['Matricula', 'FechaSalida']"
                  :pre-property-entity-shown-list-subtitle="[
                    `${$t('common.registration')}: `,
                    `${$t('common.departureDateShort')}: `,
                  ]"
                  :search-in="['.item-title', '.subtitle0']"
                  :separation-character="['/']"
                  :min-text-search="1"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventNumOrderSelected"
                >
                  <template #subtitle-1="{ item }">
                    <span>{{ `${$t('common.departureDateShort')}: ${FormatDate(item, 'DD/MM/YYYY')}` }}</span>
                  </template>
                </UCSearchEntityERP>
              </div>
              <div class="container-filters__warehouse">
                <UCSearchEntityERP
                  ref="UCWarehouseComponent"
                  :title="$t('common.originWarehouse')"
                  :placeholder="$t('searchEntity.warehouse.placeholder.searchByOrigin')"
                  :search-text="$t('searchEntity.warehouse.searchText')"
                  :search-cancellation-text="$t('searchEntity.warehouse.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.warehouse.searchNotFoundText')"
                  :end-point-for-code-search="GetStoreByCode"
                  :end-point-for-list="GetStore"
                  :property-entity-shown-input="['Codigo', 'Nombre']"
                  :property-entity-shown-list-title="['Codigo']"
                  :property-entity-shown-list-subtitle="['Nombre']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventWarehouseSelected"
                />
              </div>
              <div class="container-filters__carrier">
                <UCSearchEntityERP
                  ref="UCCarrierComponent"
                  :title="$t('common.carrier')"
                  :placeholder="$t('searchEntity.carrier.placeholder.searchByCarrier')"
                  :search-text="$t('searchEntity.carrier.searchText')"
                  :search-cancellation-text="$t('searchEntity.carrier.searchCancellationText')"
                  :search-not-found-text="$t('searchEntity.carrier.searchNotFoundText')"
                  :end-point-for-code-search="GetCarrierByCode"
                  :end-point-for-list="GetCarrier"
                  :property-entity-shown-input="['Sujeto.NombreSujeto', 'Codigo']"
                  :property-entity-shown-list-title="['Sujeto.NombreSujeto']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  @selection="EventCarrierSelected"
                />
              </div>
              <div
                v-if="paisTipoExpedicionNacional"
                class="container-filters padding-bottom"
              >
                <span class="padding-left-half no-padding-bottom">
                  {{ $t('commercialization.common.typeOfExpedition') }}
                </span>
                <UCPopover
                  id="uc-popover-main-class"
                  ref="nacionalityPopover"
                  class="uc-popover-class"
                  :sort-field-list="nacionalityListPopover"
                  :option-all="true"
                  @change-element="handleExpeditionTypeSelection"
                />
              </div>
              <!-- <div class="container-filters__carrier">
                <UCSearchEntityERP
                  ref="UCCarrierComponent"
                  title="Prueba"
                  placeholder="Buscar por transportista"
                  search-text="Buscando transportistas..."
                  search-cancellation-text="Busqueda transportistas cancelada..."
                  search-not-found-text="Transportistas no encontrados.."
                  :end-point-for-code-search="GetCarrierByCode"
                  :end-point-for-list="GetCarrier"
                  :procedure-for-search="pruebaProcedure"
                  :property-entity-shown-input="['Nombre', 'Codigo']"
                  :property-entity-shown-list-title="['Nombre']"
                  :property-entity-shown-list-subtitle="['Codigo']"
                  :min-text-search="0"
                  :autofocus-on-deselection="true"
                  :auto-focus-on-empty-search-result="true"
                  :show-total-elements="true"
                  @selection="EventCarrierSelected"
                />
              </div> -->
              <div class="container-filters__buttons">
                <img
                  src="@/static/icons/ic_reset.svg"
                  height="31"
                  width="31"
                  @click="ResetValues"
                >
                <f7-button
                  class="container-filters__buttons--search"
                  :class="{ disabled: !disableBtn }"
                  @click="FilterComplete()"
                >
                  {{ $t('common.searchNow') }}
                </f7-button>
              </div>
            </div>
          </div>
        </f7-page>
      </f7-view>
    </f7-panel>

    <UCCodeScanner
      ref="UCCodeScannerExpedition"
      :allow-manual-code-entry="true"
      :fab-button-show="false"
      @code-reading="EventBarCodeReading"
      @codigo-barras="EventBarCodeReading"
      @numero-serie="EventNumeroSerieReading"
    />

    <PCNewExpeditionActions ref="newExpeditionActions" />
  </f7-page>
</template>

<script>
import { mapState, mapWritableState } from 'pinia';
import { useAppConfigStore } from '@/js/stores/appConfig';
import { useExpeditionsStore } from '@/js/stores/expeditions';
import { useParamRef } from '@erpagroapp/params';
import { useSettingRef } from '@erpagroapp/settings';

import TheNavbar from '@/components/TheNavbar.vue';
import UCSearchEmpty from '@/components/common/UCSearchEmpty.vue';
import UCSearchEntityERP from '@/components/common/UCSearchEntityERP.vue';
import UCDatePicker from '@/components/common/UCDatePicker.vue';
import UCAcordeon from '@/components/common/UCAcordeon.vue';
import { HiDialog, HiNotification, PreloaderGH } from '@/js/common/HINotificationSupport';
import ConexionTA from '@/js/services/traceability/APITraceability';
import APIErp from '@/js/services/APIErp';
import { Log, LogError } from '@/js/common/HIDebuggingSupport';
import { HiDateTimeSupport } from '@/js/common/HIConversionSupport';
import UCPopover from '@/components/common/UCPopover.vue';
import icQr from '@/static/icons/ic_qr.svg';
import icRefreshBlue from '@/static/icons/ic_refresh_blue.svg';
import { f7 } from 'framework7-vue';
import { sleep } from '@/js/utils/sleep';
import UCCodeScanner from '@/components/common/UCCodeScanner.vue';
import PCNewExpeditionActions from '@/components/production/commercialization/expedition/PCNewExpeditionActions.vue';

export default {
  name: 'FrmExpedition',

  components: {
    TheNavbar,
    UCSearchEmpty,
    UCSearchEntityERP,
    UCAcordeon,
    UCDatePicker,
    UCCodeScanner,
    PCNewExpeditionActions,
    UCPopover,
  },

  props: {
    reload: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      icQr,
      icRefreshBlue,
      elementFilter: [
        {
          NombreAgrupacion: this.$t('commercialization.common.finishedLoads').toUpperCase(),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'cfin',
        },
        {
          NombreAgrupacion: this.$t('commercialization.common.pendingLoads').toUpperCase(),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'cpen',
        },
        {
          NombreAgrupacion: this.$t('commercialization.common.inProcessLoads').toUpperCase(),
          items: [],
          Preload: false,
          LoadStatus: false,
          Id: 'cpro',
        },
      ], // Elementos que hay que mostrar en el acordeon
      // expeditions: [], // expediciones SIN FILTRAR Y SIN ORDENAR
      panelDerecho: null,
      clientSelected: null,
      orderSelected: null,
      articlesSelected: null,
      tuitionSelected: null,
      numOrderSelected: null,
      warehouseSelected: null,
      carrierSelected: null,
      nacionalitySelected: '',
      showNoExpeditions: false,
      dateFilter: null,
      newDateDatePicker: new Date(),
      expeditionFilters: {
        Cliente: null,
        Pedido: null,
        Articulo: null,
        Matricula: null,
        Orden: null,
        Almacen: null,
        Transportista: null,
        Nacionalidad: '',
      },
      disableDatePicker: false,
      clientList: [],
      orderList: [],
      articleList: [],
      tuitionList: [],
      numOrderList: [],
      wareHouseList: [],
      carrierList: [],
      nacionality: '',
      nacionalityListPopover: ['NACIONAL', 'EXTRANJERA'],
      introduccionManualCBLecturaPalesExpeciones: useParamRef('IntroduccionManualCBLecturaPalesExpeciones'),
      showAddressName: useSettingRef('Expediciones.MostrarNombreDireccion'),
      permitirGenerarOrdenesCargaSinPedidoEnMovilidad: useParamRef('PermitirGenerarOrdenesCargaSinPedidoEnMovilidad'),
      paisTipoExpedicionNacional: useParamRef('PaisTipoExpedicionNacional'),

    };
  },

  computed: {
    ...mapState(useAppConfigStore, ['userEnviroment']),

    ...mapWritableState(useExpeditionsStore, [
      'itemAcordeonOpen',
      'filtersExpedition',
    ]),
    appTheme() {
      return {
        '--f7-navbar-bg-color': 'var(--his-slate-blue)',
      };
    },

    disableBtn() {
      return (
        this.clientSelected !== null
        || this.orderSelected !== null
        || this.articlesSelected !== null
        || this.tuitionSelected !== null
        || this.numOrderSelected !== null
        || this.warehouseSelected !== null
        || this.carrierSelected !== null
        || this.nacionalitySelected !== ''
      );
    },
  },

  async mounted() {
    if (this.reload) {
      this.SearchWithValuesStore();
      await sleep(1000);
      f7.views.main.router.clearPreviousHistory();
    } else {
      this.StartComponent();
    }
  },

  methods: {
    StartComponent() {
      Log(this, this.StartComponent.name);
      /* this.dateFilter = HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD');
      this.dateFilterExpedition = new Date();
      this.GetMainData(); */
      this.SearchWithValuesStore();
    },

    async GetMainData() {
      Log(this, this.GetMainData.name);
      // this.expeditions = [];
      this.elementFilter[0].Preload = true;
      this.elementFilter[0].LoadStatus = false;
      this.elementFilter[0].items = [];

      const noDate = this.numOrderSelected != null;
      this.LoadExpeditionInProcess(noDate);
      this.LoadExpeditionPending(noDate);
      /* await this.$refs.UCAcordeon.OpenItem('cpro'); */
      // this.LoadExpeditionFinalized();
    },

    RefreshMainData() {
      Log(this, this.RefreshMainData.name);

      this.GetMainData();

      const open = this.$refs.UCAcordeon.ElementOpen('cfin');
      if (open) {
        this.LoadExpeditionFinalized(this.numOrderSelected != null);
      }
    },

    PushDataToList() {
      if (this.clientSelected != null) {
        this.clientList.push(this.clientSelected);
      }
      if (this.orderSelected != null) {
        this.orderList.push(this.orderSelected);
      }
      if (this.articlesSelected != null) {
        this.articleList.push(this.articlesSelected);
      }
      if (this.tuitionSelected != null) {
        this.tuitionList.push(this.tuitionSelected.Matricula);
      }
      if (this.numOrderSelected != null) {
        this.numOrderList.push(this.numOrderSelected);
      }
      if (this.warehouseSelected != null) {
        this.wareHouseList.push(this.warehouseSelected);
      }
      if (this.carrierSelected != null) {
        this.carrierList.push(this.carrierSelected);
      }

      if (this.paisTipoExpedicionNacional) {
        if (this.nacionalitySelected !== '' && this.nacionalitySelected !== 'TODOS') {
          this.nacionality = this.expeditionFilters.Nacionalidad;
        }
      }
    },

    ResetLists() {
      this.clientList = [];
      this.orderList = [];
      this.articleList = [];
      this.tuitionList = [];
      this.numOrderList = [];
      this.wareHouseList = [];
      this.carrierList = [];
      this.nacionality = '';
    },
    async LoadExpeditionInProcess(noDate) {
      Log(this, this.LoadExpeditionInProcess.name);
      this.elementFilter[1].items = [];
      this.elementFilter[1].Preload = true;
      if (noDate) {
        this.elementFilter[1].items = await this.Conections_GetExpeditionsLines(
          '',
          '',
          [0],
          this.clientList,
          this.orderList,
          this.articleList,
          this.tuitionList,
          this.numOrderList,
          this.wareHouseList,
          this.carrierList,
          this.nacionality,
        );
      } else {
        this.elementFilter[1].items = await this.Conections_GetExpeditionsLines(
          `${this.dateFilter} 00:00:00`,
          `${this.dateFilter} 23:59:59`,
          [0],
          this.clientList,
          this.orderList,
          this.articleList,
          this.tuitionList,
          this.numOrderList,
          this.wareHouseList,
          this.carrierList,
          this.nacionality,
        );
      }

      this.elementFilter[1].Preload = false;
      this.elementFilter[1].LoadStatus = true; // Estado de la carga
    },
    async LoadExpeditionPending(noDate) {
      Log(this, this.LoadExpeditionPending.name);
      this.elementFilter[2].items = [];
      this.elementFilter[2].Preload = true;

      if (noDate) {
        this.elementFilter[2].items = await this.Conections_GetExpeditionsLines(
          '',
          '',
          [1],
          this.clientList,
          this.orderList,
          this.articleList,
          this.tuitionList,
          this.numOrderList,
          this.wareHouseList,
          this.carrierList,
          this.nacionality,
        );
      } else {
        this.elementFilter[2].items = await this.Conections_GetExpeditionsLines(
          `${this.dateFilter} 00:00:00`,
          `${this.dateFilter} 23:59:59`,
          [1],
          this.clientList,
          this.orderList,
          this.articleList,
          this.tuitionList,
          this.numOrderList,
          this.wareHouseList,
          this.carrierList,
          this.nacionality,
        );
      }
      this.elementFilter[2].Preload = false;
      this.elementFilter[2].LoadStatus = true; // Estado de la carga
    },
    async LoadExpeditionFinalized(noDate) {
      Log(this, this.LoadExpeditionFinalized.name);
      this.elementFilter[0].items = [];
      this.elementFilter[0].Preload = true;
      if (noDate) {
        this.elementFilter[0].items = await this.Conections_GetExpeditionsLines(
          '',
          '',
          [2],
          this.clientList,
          this.orderList,
          this.articleList,
          this.tuitionList,
          this.numOrderList,
          this.wareHouseList,
          this.carrierList,
          this.nacionality,
        );
      } else {
        this.elementFilter[0].items = await this.Conections_GetExpeditionsLines(
          `${this.dateFilter} 00:00:00`,
          `${this.dateFilter} 23:59:59`,
          [2],
          this.clientList,
          this.orderList,
          this.articleList,
          this.tuitionList,
          this.numOrderList,
          this.wareHouseList,
          this.carrierList,
          this.nacionality,
        );
      }

      this.elementFilter[0].Preload = false;
      this.elementFilter[0].LoadStatus = true; // Estado de la carga
    },
    BackToMain() {
      f7.views.main.router.clearPreviousHistory();
      f7.views.main.router.navigate('/', { force: true });
    },
    Valor(presed) {
      Log(this, this.Valor.name);
      this.panelDerecho = presed;
    },
    SearchWithValuesStore() {
      Log(this, this.SearchWithValuesStore.name);
      /* if (this.dateFilterExpedition != null) {
        this.dateFilter = HiDateTimeSupport.FormatDateTime(this.dateFilterExpedition, 'YYYY-MM-DD');
        this.$refs.datepicker.setDate(this.dateFilterExpedition);
      } else {
        this.dateFilter = HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD');
        this.$refs.datepicker.setDate(new Date());
      } */
      this.dateFilter = HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD');
      this.$refs.datepicker.setDate(new Date());

      this.clientSelected = this.filtersExpedition.Cliente;
      this.orderSelected = this.filtersExpedition.Pedido;
      this.articlesSelected = this.filtersExpedition.Articulo;
      this.tuitionSelected = this.filtersExpedition.Matricula;
      this.numOrderSelected = this.filtersExpedition.Orden;
      this.warehouseSelected = this.filtersExpedition.Almacen;
      this.carrierSelected = this.filtersExpedition.Transportista;

      // this.nacionalitySelected = this.filtersExpedition.Nacionalidad;

      // if (this.paisTipoExpedicionNacional) {
      //   if (this.nacionalitySelected !== '' && this.nacionalitySelected !== 'TODOS') {
      //     this.filtersExpedition.Nacionalidad = this.paisTipoExpedicionNacional;
      //   } else {
      //   }
      // }

      this.expeditionFilters.Cliente = this.filtersExpedition.Cliente;
      this.expeditionFilters.Pedido = this.filtersExpedition.Pedido;
      this.expeditionFilters.Articulo = this.filtersExpedition.Articulo;
      this.expeditionFilters.Matricula = this.filtersExpedition.Matricula;
      this.expeditionFilters.Orden = this.filtersExpedition.Orden;
      this.expeditionFilters.Almacen = this.filtersExpedition.Almacen;
      this.expeditionFilters.Transportista = this.filtersExpedition.Transportista;
      this.expeditionFilters.Nacionalidad = this.filtersExpedition.Nacionalidad;

      if (this.clientSelected != null) {
        this.$refs.UCClientComponent.SelectEntity(this.clientSelected, false);
      }
      if (this.orderSelected != null) {
        this.$refs.UCOrderComponent.SelectEntity(this.orderSelected, false);
        this.orderSelected = this.orderSelected.LineaPedidoVenta.PedidoVenta;
      }
      if (this.articlesSelected != null) {
        this.$refs.UCArticlesComponent.SelectEntity(this.articlesSelected, false);
      }
      if (this.tuitionSelected != null) {
        this.$refs.UCTuitionComponent.SelectEntity(this.tuitionSelected, false);
      }
      if (this.numOrderSelected != null) {
        this.$refs.UCNumOrderComponent.SelectEntity(this.numOrderSelected, false);
      }
      if (this.warehouseSelected != null) {
        this.$refs.UCWarehouseComponent.SelectEntity(this.warehouseSelected, false);
      }
      if (this.carrierSelected != null) {
        this.$refs.UCCarrierComponent.SelectEntity(this.carrierSelected, false);
      }
      if (this.paisTipoExpedicionNacional) {
        if (this.nacionalitySelected !== '') {
          this.$refs.nacionalityPopover.changeSortElement(this.nacionalitySelected);
        } else {
          this.$refs.nacionalityPopover.changeSortElement('TODOS');
        }
      }

      if (this.numOrderSelected != null) {
        this.PushDataToList();
        this.GetMainData();
        this.LoadExpeditionFinalized(true);
        this.ResetLists();
        this.$refs.datepicker.resetToCurrentDate();
        this.$refs.datepicker.resetToNullValue();
        this.disableDatePicker = true;
      } else {
        this.PushDataToList();
        this.GetMainData();
        if (this.itemAcordeonOpen === 0) {
          this.LoadExpeditionFinalized(false);
        }
        this.ResetLists();
      }
      this.AddToSearch();
    },

    ResetValues() {
      Log(this, this.ResetValues.name);
      this.clientSelected = null;
      this.orderSelected = null;
      this.articlesSelected = null;
      this.tuitionSelected = null;
      this.numOrderSelected = null;
      this.warehouseSelected = null;
      this.carrierSelected = null;
      this.nacionalitySelected = '';

      this.$refs.UCClientComponent.Clear();
      this.$refs.UCOrderComponent.Clear();
      this.$refs.UCArticlesComponent.Clear();
      this.$refs.UCTuitionComponent.Clear();
      this.$refs.UCNumOrderComponent.Clear();
      this.$refs.UCWarehouseComponent.Clear();
      this.$refs.UCCarrierComponent.Clear();
      this.$refs.PCBuscador.SetValueInput('');
      if (this.paisTipoExpedicionNacional) {
        this.$refs.nacionalityPopover.changeSortElement('TODOS');
      }

      this.expeditionFilters.Cliente = null;
      this.expeditionFilters.Pedido = null;
      this.expeditionFilters.Articulo = null;
      this.expeditionFilters.Matricula = null;
      this.expeditionFilters.Orden = null;
      this.expeditionFilters.Almacen = null;
      this.expeditionFilters.Transportista = null;
      this.expeditionFilters.Nacionalidad = '';

      this.filtersExpedition = this.expeditionFilters;
      /* if (this.dateFilterExpedition != null) {
        this.dateFilter = HiDateTimeSupport.FormatDateTime(this.dateFilterExpedition, 'YYYY-MM-DD');
        this.$refs.datepicker.setDate(this.dateFilterExpedition);
      } else {
        this.dateFilter = HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD');
        this.$refs.datepicker.setDate(new Date());
      } */
      this.dateFilter = HiDateTimeSupport.FormatDateTime(new Date(), 'YYYY-MM-DD');
      this.$refs.datepicker.setDate(new Date());
      this.disableDatePicker = false;
      this.PushDataToList();
      this.GetMainData();
      if (this.itemAcordeonOpen === 0) {
        this.LoadExpeditionFinalized(false);
      }
      this.ResetLists();
    },
    FilterComplete() {
      Log(this, this.FilterComplete.name);
      this.filtersExpedition = this.expeditionFilters;
      /* this.Conections_GetExpeditionsLines(`${this.dateFilter} 00:00:00`, `${this.dateFilter} 23:59:59`, this.clientSelected, this.orderSelected,
        this.articlesSelected, this.tuitionSelected, this.numOrderSelected,
        this.warehouseSelected, this.carrierSelected); */
      if (this.numOrderSelected != null) {
        this.disableDatePicker = true;
        this.PushDataToList();
        this.GetMainData();
        if (this.itemAcordeonOpen === 0) {
          this.LoadExpeditionFinalized(true);
        }
        this.ResetLists();
        this.$refs.datepicker.resetToCurrentDate(false);
        this.$refs.datepicker.resetToNullValue(false);
      } else {
        this.disableDatePicker = false;
        this.PushDataToList();
        this.GetMainData();
        if (this.itemAcordeonOpen === 0) {
          this.LoadExpeditionFinalized(false);
        }
        this.ResetLists();
      }
      this.AddToSearch();
    },
    AddToSearch() {
      let sinNada = true;
      let cadenaClient = '';
      let cadenaPedido = '';
      let cadenaArticulo = '';
      let cadenaMatricula = '';
      let cadenaOrden = '';
      let cadenaAlmacen = '';
      let cadenaTransportista = '';
      let cadenaNacionalidad = '';

      if (this.clientSelected != null) {
        cadenaClient = `${this.$t('common.customer')}: ${cadenaClient.concat(this.clientSelected.Nombre)}, `;
        sinNada = false;
      }
      if (this.orderSelected != null) {
        cadenaPedido = `${this.$t('common.salesOrderShort')}: ${cadenaPedido.concat(
          this.orderSelected.Serie,
          '/',
          this.orderSelected.Numero,
        )}, `;
      }
      if (this.articlesSelected != null) {
        cadenaArticulo = `${this.$t('common.article')}: ${cadenaArticulo.concat(this.articlesSelected.Nombre)}, `;
        sinNada = false;
      }
      if (this.tuitionSelected != null) {
        cadenaMatricula = `${this.$t('common.registration')}: ${cadenaMatricula.concat(this.tuitionSelected.Matricula)}, `;
        sinNada = false;
      }
      if (this.numOrderSelected != null) {
        cadenaOrden = `${this.$t('common.order')}: ${cadenaOrden.concat(this.numOrderSelected.Numero)}, `;
        sinNada = false;
      }
      if (this.warehouseSelected != null) {
        cadenaAlmacen = `${this.$t('common.originWarehouse')}: ${cadenaAlmacen.concat(this.warehouseSelected.Nombre)}, `;
        sinNada = false;
      }
      if (this.carrierSelected != null) {
        cadenaTransportista = `${this.$t('common.carrier')}: ${cadenaTransportista.concat(this.carrierSelected.Sujeto.NombreSujeto)} `;
        sinNada = false;
      }
      if (this.nacionalitySelected !== '' && this.nacionalitySelected !== 'TODOS') {
        cadenaNacionalidad = `${this.$t('common.nationality')}: ${cadenaNacionalidad.concat(this.nacionalitySelected)} `;
        sinNada = false;
      }
      if (sinNada) {
        this.$refs.PCBuscador.SetValueInput('');
      } else {
        this.$refs.PCBuscador.SetValueInput(
          `${cadenaClient} ${cadenaPedido} ${cadenaArticulo} ${cadenaMatricula} ${cadenaOrden} ${cadenaAlmacen} ${cadenaTransportista} ${cadenaNacionalidad}`,
        );
      }
    },
    FormatDate(stringDate, format) {
      return HiDateTimeSupport.FormatDateTime(stringDate, format);
    },
    async FilterByLoadedPallet(pale) {
      Log(this, this.FilterByLoadedPallet.name);
      let concidencia = false;

      const preloaderText = this.$t('commercialization.info.searchingLoadedPallet');
      const cancellationText = this.$t('common.searchCancelled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      await this.LoadExpeditionFinalized(false);
      await this.LoadExpeditionInProcess(false);
      // Finalizadas filtrar
      this.elementFilter[0].items.forEach((element) => {
        element.Desglose.forEach((des) => {
          if (des.UnidadContenedora != null) {
            if (des.UnidadContenedora.NumeroSerie === pale.NumeroSerie && des.Estado === 2) {
              this.NavigateToEditExpeditionLine(element, pale.NumeroSerie);
              concidencia = true;
            }
          }
        });
      });
      // en proceso filtrar
      this.elementFilter[2].items.forEach((element) => {
        element.Desglose.forEach((des) => {
          if (des.UnidadContenedora != null) {
            if (des.UnidadContenedora.NumeroSerie === pale.NumeroSerie && des.Estado === 2) {
              this.NavigateToEditExpeditionLine(element, pale.NumeroSerie);
              concidencia = true;
            }
          }
        });
      });
      PreloaderGH(false);

      if (!concidencia) {
        HiNotification.Toast(this.$t('commercialization.info.noLoadedPalletsFound'));
      }
    },

    GetItemAfterClassByQuantity(item) {
      if (item.CantidadTotalCargada === 0) {
        return 'pending';
      }
      if (item.CantidadTotalCargada === item.CantidadTotalPales) {
        return 'finished';
      }
      return 'in-process';
    },

    NavigateToEditExpeditionLine(objLineExpedition, numeroSerie) {
      Log(this, this.NavigateToEditExpeditionLine.name);
      f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocumentAddPale', {
        props: {
          lineExpedition: objLineExpedition,
          expedition: objLineExpedition.Expedicion,
          filtradoPorNumeroSerie: numeroSerie,
        },
      });
    },

    ChangedDateFilter(newDateValue) {
      Log(this, this.ChangedDateFilter.name);
      // this.dateFilterExpedition = newDateValue;
      this.dateFilter = HiDateTimeSupport.FormatDateTime(newDateValue, 'YYYY-MM-DD');
      const open = this.$refs.UCAcordeon.ElementOpen('cfin');
      this.PushDataToList();
      if (open) {
        this.LoadExpeditionFinalized(this.numOrderSelected != null);
      }
      this.GetMainData();
      this.ResetLists();
      this.elementFilter[0].LoadStatus = false; // Estado de la carga
      this.elementFilter[0].items = [];
      // this.Conections_GetExpeditionsLines(`${this.dateFilter} 00:00:00`, `${this.dateFilter} 23:59:59`);
    },
    NavigateToExpeditionDocument(objExpetitionLine) {
      Log(this, this.NavigateToExpeditionDocument.name);
      if (objExpetitionLine.LineaPedidoVenta != null) {
        f7.views.main.router.navigate('/commercialisation/expedition/frmExpeditionDocument/', {
          props: {
            expeditionDocument: objExpetitionLine.Expedicion,
          },
        });
      } else {
        f7.views.main.router.navigate('/commercialisation/expedition/noSalesOrder/frmExpeditionDocumentNoSales', {
          props: {
            expeditionDocument: objExpetitionLine.Expedicion,
          },
        });
      }
    },
    OpenNewExpedition() {
      Log(this, this.OpenNewExpedition.name);
      if (this.permitirGenerarOrdenesCargaSinPedidoEnMovilidad) {
        this.OpenNewExpeditionActions();
      } else {
        f7.views.main.router.navigate(
          '/commercialisation/expedition/frmExpeditionEditLines',
        );
      }
    },
    OpenNewExpeditionActions() {
      Log(this, this.OpenNewExpeditionActions.name);
      this.$refs.newExpeditionActions?.openActions();
    },

    EventClientSelected(obj) {
      Log(this, this.EventClientSelected.name);
      this.expeditionFilters.Cliente = obj;
      this.clientSelected = obj;
    },
    EventOrderSelected(obj) {
      Log(this, this.EventOrderSelected.name);
      if (obj !== null) {
        this.expeditionFilters.Pedido = obj;
        this.orderSelected = obj.LineaPedidoVenta.PedidoVenta;
      } else {
        this.orderSelected = null;
      }
    },
    EventArticlesSelected(objSelected) {
      Log(this, this.EventArticlesSelected.name);
      this.expeditionFilters.Articulo = objSelected;
      this.articlesSelected = objSelected;
    },
    EventTuitionSelected(objSelected) {
      Log(this, this.EventTuitionSelected.name);
      this.expeditionFilters.Matricula = objSelected;
      this.tuitionSelected = objSelected;
    },
    EventNumOrderSelected(objSelected) {
      Log(this, this.EventNumOrderSelected.name);
      this.expeditionFilters.Orden = objSelected;
      this.numOrderSelected = objSelected;
    },
    EventWarehouseSelected(objSelected) {
      Log(this, this.EventWarehouseSelected.name);
      this.expeditionFilters.Almacen = objSelected;
      this.warehouseSelected = objSelected;
    },
    EventCarrierSelected(objSelected) {
      Log(this, this.EventCarrierSelected.name);
      this.expeditionFilters.Transportista = objSelected;
      this.carrierSelected = objSelected;
    },

    handleExpeditionTypeSelection(value) {
      Log(this, this.handleExpeditionTypeSelection.name);
      const upperValue = value.toUpperCase();
      let nacionalidad = '';
      let nacionality = '';

      switch (upperValue) {
        case 'TODOS':
          nacionalidad = '';
          nacionality = '';
          break;

        case 'NACIONAL':
          nacionalidad = this.paisTipoExpedicionNacional;
          nacionality = this.paisTipoExpedicionNacional;
          break;

        default:
          nacionalidad = `-${this.paisTipoExpedicionNacional}`;
          nacionality = `-${this.paisTipoExpedicionNacional}`;
          break;
      }
      this.expeditionFilters.Nacionalidad = nacionalidad;
      this.nacionality = nacionality;
      this.nacionalitySelected = value;
    },

    async EventSelectedElemenParentAcordeon(e) {
      Log(this, this.EventSelectedElemenParentAcordeon.name);
      // TODO: Se debe comprobar otra cosa que no sea el nombre de la agrupacion.
      if (e.NombreAgrupacion === this.$t('commercialization.common.finishedLoads').toUpperCase()) {
        this.itemAcordeonOpen = 0;
        // TODO: Se debe comprobar otra cosa que no sea el nombre de la agrupacion.
      } else if (e.NombreAgrupacion === this.$t('commercialization.common.pendingLoads').toUpperCase()) {
        this.itemAcordeonOpen = 1;
      } else {
        this.itemAcordeonOpen = 2;
      }
      // TODO: Se debe comprobar otra cosa que no sea el nombre de la agrupacion.
      if (!e.LoadStatus && e.NombreAgrupacion === this.$t('commercialization.common.finishedLoads').toUpperCase()) {
        this.PushDataToList();
        this.LoadExpeditionFinalized(this.numOrderSelected != null);
        this.ResetLists();
      }
    },
    async EventOpenReadAns() {
      Log(this, this.EventOpenReadAns.name);
      if (this.introduccionManualCBLecturaPalesExpeciones) {
        this.$refs.UCCodeScannerExpedition.Open();
        await sleep(200);
        this.$refs.UCCodeScannerExpedition.SetFocusOnInputElement();
      } else {
        this.$refs.UCCodeScannerExpedition.OpenAuto();
      }
    },
    async EventBarCodeReading(code) {
      Log(this, this.EventBarCodeReading.name);
      let paleLeido = null;
      HiDialog.Preloader(true, this.$t('codeScanner.info.validatingBarcode'));
      const result = await ConexionTA.callObtenePalePorCodigoDeBarras(code, true, false, true);
      HiDialog.Preloader(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        this.FilterByLoadedPallet(paleLeido);
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      }
    },

    async EventNumeroSerieReading(code) {
      Log(this, this.EventNumeroSerieReading.name);
      let paleLeido = null;

      const preloaderText = this.$t('codeScanner.info.validatingSerialNumber');
      const cancellationText = this.$t('codeScanner.info.validationCanceled');
      PreloaderGH(true, true, preloaderText, cancellationText);

      const result = await ConexionTA.callObtenePalePorNumeroDeSerie(code, true, true, false);
      PreloaderGH(false);
      if (result.Valor) {
        paleLeido = JSON.parse(result.Mensaje);
        this.FilterByLoadedPallet(paleLeido);
      } else {
        HiNotification.Alert(result.Mensaje, this.$t('common.error'));
      }
    },

    /** ** ************ CONNECTIONS  */
    /* almacenes */
    GetStore() {
      Log(this, this.GetStore.name);
      return APIErp.callGetStore();
    },
    GetStoreByCode(params) {
      Log(this, this.GetStoreByCode.name);
      return APIErp.callGetStore(params);
    },
    /* clientes */
    GetCustomers() {
      Log(this, this.GetCustomers.name);
      return APIErp.callGetCustomers();
    },
    GetCustomersByCode(filter) {
      Log(this, this.GetCustomersByCode.name);
      return APIErp.callGetCustomers(filter);
    },
    /* pedidos */
    GetSalesOrder() {
      Log(this, this.GetSalesOrder.name);
      return APIErp.callSalesOrderLinesAvailableForExpedition();
    },
    GetSalesOrderByFilter(filter) {
      Log(this, this.GetSalesOrderByFilter.name);
      return APIErp.callSalesOrderLinesAvailableForExpedition(filter);
    },

    GetArticles() {
      Log(this, this.GetArticles.name);
      return APIErp.callGetArticlesExpedition();
    },
    GetArticlesByCode(params) {
      Log(this, this.GetArticlesByCode.name);
      return APIErp.callGetArticlesExpedition(params);
    },

    GetPlates() {
      Log(this, this.GetPlates.name);
      return APIErp.callGetVehicle();
    },
    GetPlatesByCode(params) {
      Log(this, this.GetPlatesByCode.name);
      return APIErp.callGetVehicle(params);
    },

    GetOrder() {
      Log(this, this.GetOrder.name);
      const params = {};
      params.Centro = this.userEnviroment.EntornoDeTrabajo.Centro;
      return APIErp.callGetExpeditions(params);
    },
    GetExpeditionByCode(stringFilter) {
      Log(this, this.GetExpeditionByCode.name);
      const params = {};
      if (stringFilter.includes('/')) {
        const arr = stringFilter.split('/');
        params.Expedicion = {
          Serie: arr[0],
          Numero: arr[1],
        };
      } else {
        params.Expedicion = {
          Numero: stringFilter,
        };
      }
      params.Centro = this.userEnviroment.EntornoDeTrabajo.Centro;
      return APIErp.callGetExpeditions(params);
    },

    GetCarrier() {
      Log(this, this.GetCarrier.name);
      return APIErp.callGetCarrier();
    },
    GetCarrierByCode(params) {
      Log(this, this.GetCarrierByCode.name);
      return APIErp.callGetCarrier(params);
    },

    async Conections_GetExpeditionsLines(
      fechaDesde,
      fechaHasta,
      estadosOrdenCarga,
      cliente,
      pedido,
      articulo,
      matricula,
      numExpedicion,
      almacen,
      transportista,
      nacionalidad,
    ) {
      Log(this, this.Conections_GetExpeditionsLines.name);
      const resLines = [];
      const self = this;
      const filtro = {};
      filtro.FechaDesde = fechaDesde;
      filtro.FechaHasta = fechaHasta;
      filtro.EstadoOrdenCarga = estadosOrdenCarga;
      if (cliente !== null) {
        filtro.Cliente = cliente;
      }
      if (pedido !== null) {
        filtro.PedidoVenta = pedido;
      }
      if (articulo !== null) {
        filtro.Articulo = articulo;
      }
      if (matricula !== null) {
        filtro.Matricula = matricula;
      }
      if (numExpedicion !== null) {
        filtro.Expedicion = numExpedicion;
      }
      if (almacen !== null) {
        filtro.Almacen = almacen;
      }
      if (transportista !== null) {
        filtro.Transportista = transportista;
      }

      filtro.Centro = this.userEnviroment.EntornoDeTrabajo.Centro;
      filtro.Nacionalidad = nacionalidad;

      self.panelDerecho = false;
      try {
        const result = await APIErp.callGetExpeditions(filtro);
        if (result.statusText === 'OK' || result.status === 200) {
          result.data.forEach((x) => {
            if (x.Lineas != null) {
              resLines.push(...x.Lineas);
            }
          });
        }
      } catch (error) {
        LogError(self, self.Conections_GetExpeditionsLines.name, error);
      }
      return resLines;
    },
  },
};
</script>

<style lang="scss">
.main-frmexpedition {
  // TODO: Remove when migrated to new styles
  --f7-list-item-min-height: 48px;
  --f7-list-item-padding-horizontal: 16px;
  --f7-list-item-title-font-size: 15px;
  --f7-list-item-subtitle-font-weight: 400;
  --f7-list-item-padding-vertical: 0;
  --f7-list-item-footer-font-size: 12px;
  --f7-list-item-title-line-height: 1;
  --f7-list-chevron-icon-font-size: 20px;
  --f7-list-margin-vertical: 0;
  --f7-list-border-color: rgb(0 0 0 / 12%);

  .storybook-action-sorted-accordion .accordion-list .sorted-accordion > .item-inner .item-link .item-title {
    padding: 10px 10px 10px 0;
  }

  .accordion-item-opened > .accordion-item-content {
    padding-bottom: 0;
    background: transparent;
    border-bottom: 0;
  }
  //

  .navbar-frmexpedition {
    .navbar-inner {
      .left {
        max-width: calc(100% - 115px);
      }

      .right .link {
        padding: 0;
        justify-content: center;
      }
    }
  }

  .content-accordion {
    .storybook-action-sorted-accordion {
      .accordion-list {
        ul {
          .accordion-item-opened {
            .item-link {
              &::after {
                border-top: 0;
              }

              .item-content {
                background-color: #fff;
                padding-right: 5px;
              }
            }
          }
        }
      }
    }

    .accordion-item-content {
      --f7-list-item-title-text-color: var(--his-oliva) !important;
      --f7-list-item-title-font-size: 12px;
      --f7-list-media-item-title-font-weight: 400;
      --f7-list-item-after-font-size: 12px;
      --f7-list-item-after-font-weight: 500;
      --f7-list-item-subtitle-font-size: 14px;
      --f7-list-item-subtitle-line-height: 1.2;
      --f7-list-item-text-font-size: 12px;
      --f7-list-item-text-text-color: var(--his-ash-gray);
      --f7-list-item-text-line-height: 1;
      --f7-list-chevron-icon-color: var(--his-oliva);
      --f7-list-item-footer-text-color: var(--his-oliva);
      --f7-list-item-footer-line-height: 2;
      --f7-list-item-footer-font-weight: 400;
      --f7-badge-bg-color: var(--his-light-blue);

      .item-title-row {
        align-items: center;
        padding-right: 16px;
      }

      .item-subtitle {
        -webkit-box-orient: vertical;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: normal;
        margin: 6px 0;
        padding-right: 16px;
      }

      .item-title {
        >div {
          display: flex;
        }

        &__date {
          color: var(--his-slate-blue);
          background-color: var(--his-light-blue);
          font-weight: 400;
          padding: 4px 8px;
          border-radius: 3px;
          margin-right: 5px;
        }

        &__info {
          padding: 4px 8px;
          border-radius: 3px;
          background-color: #f9faff;
          margin-right: 5px;
        }

        @media only screen and (max-width: 400px) {
          &__info {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }
        }

        &__serieNumeroOrden {
          display: inline-block;
          color: var(--his-slate-blue);
          background-color: var(--his-mandarina-tint);
          font-weight: 500;
          padding: 4px 8px;
          border-radius: 3px;
          margin-right: 5px;
        }
      }

      .item-after-info {
        background-color: var(--expedition-item-after-info-bg-color);
        color: var(--expedition-item-after-info-color);
        padding: 4px 8px;
        border-radius: 3px;
        line-height: 1;

        &.in-process {
          --expedition-item-after-info-bg-color: var(--his-mandarina-tint);
          --expedition-item-after-info-color: #ba5333;
        }

        &.pending {
          --expedition-item-after-info-bg-color: var(--his-disabled);
          --expedition-item-after-info-color: var(--his-oliva);
        }

        &.finished {
          --expedition-item-after-info-bg-color: #e5f6d3;
          --expedition-item-after-info-color: #66ba33;
        }
      }
    }

    .storybook-action-sorted-accordion .sorted-accordion:first-child > .item-inner {
      --f7-badge-bg-color: #d9def0;
      --f7-badge-size: 24px;
      --f7-badge-font-weight: 400;
      --f7-badge-font-size: 13px;
      --f7-badge-text-color: var(--his-oliva);

      .item-link {
        background-color: var(--his-light-blue);
        --f7-list-item-title-text-color: var(--his-slate-blue);

        &::before {
          color: var(--his-slate-blue) !important;
        }

        &::after {
          color: var(--his-slate-blue) !important;
        }
      }
    }

    .storybook-action-sorted-accordion .sorted-accordion:nth-child(2) > .item-inner {
      --f7-badge-bg-color: #fce0b1;
      --f7-badge-size: 24px;
      --f7-badge-font-weight: 400;
      --f7-badge-font-size: 13px;
      --f7-badge-text-color: #ba5333;

      .item-link {
        background-color: var(--his-mandarina-tint);
        --f7-list-item-title-text-color: var(--his-slate-blue);

        &::before {
          color: var(--his-slate-blue) !important;
        }
      }
    }

    .storybook-action-sorted-accordion .sorted-accordion:nth-child(3) > .item-inner {
      --f7-badge-bg-color: var(--his-oliva-light);
      --f7-badge-size: 24px;
      --f7-badge-font-weight: 400;
      --f7-badge-font-size: 13px;
      --f7-badge-text-color: var(--his-dark-blue);
    }
  }

  .disabled {
    opacity: 0.6;
    pointer-events: none;
  }

  .bloque-busqueda {
    background-color: var(--his-slate-blue);

    .container-filtros {
      display: flex;
      align-content: space-between;
      justify-content: flex-start;

      .input-searcher {
        margin-right: 16px;
        height: 32px;
        width: 100%;

        input {
          height: 32px;
          border-bottom-left-radius: 3px;
          border-top-left-radius: 3px;

          &::placeholder {
            font-size: 12px;
            color: var(--his-oliva);
          }
        }

        .container__img {
          height: 32px;
          width: auto;
          padding: 0 12px;
          border-bottom-right-radius: 3px;
          border-top-right-radius: 3px;

          img {
            height: 14px;
            width: 14px;
          }
        }
      }

      .input-date {
        --date-picker-input-height: 32px;
        --date-picker-input-border-radius: 3px;
        --date-picker-input-color: var(--his-slate-blue);
        --date-picker-input-font-size: 13px;
        --date-picker-input-font-weight: 400;
        --date-picker-input-border: 0;
        --date-picker-btn-min-width: 32px;
        --date-picker-btn-search-img-size: 14px;

        width: 120px;
        min-width: 120px;
      }
    }

    &__texto {
      display: flex;
      align-items: center;
      justify-content: flex-start;

      span {
        font-size: 11px;
        color: var(--his-blueberry-frost);
        margin-left: 4px;
      }
    }
  }

  .scan-code {
    z-index: 1;
    overflow-y: hidden;
    position: absolute;
    top: 45%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 65%;
    height: 37%;
    border-radius: 15px;
    box-shadow: 0 0 0 2000px rgb(0 0 0 / 40%);

    @media (max-width: 320px) {
      top: 50%;
    }

    @media (max-width: 360px) {
      top: 53%;
    }
  }

  .content-scan {
    background-color: #222;
  }
}

.div_Fecha-Ref {
  font-size: 14px;
}

.span_Fecha-Ref {
  margin-left: 15px;
}

.bloque-busqueda__date {
  background: #fff;
  border-radius: 5px;
  width: 125px;
  margin-left: -30px;
  height: 32px;
  padding-top: 15px;
  color: var(--his-slate-blue);
}

.bloque-no-expeditions {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 30px;
}

.bloque-no-expeditions__img {
  width: 61px;
  height: 61px;
  text-align: center;
}

.bloque-no-expeditions__text {
  font-style: normal;
  font-weight: 500;
  font-size: 18px;
  line-height: 26px;
  color: var(--his-ash-gray);
}

.bloque-no-expeditions__text2 {
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 20px;
  color: #aaa1a1;
}

.bloque-no-expeditions__img2 {
  width: 15px;
  height: 15px;
}

.panel-container {
  background-color: #f6f6f6;
}

.container-filters {
  display: flex;
  flex-direction: column;
  background-color: #f6f6f6;

  --f7-block-padding-horizontal: 12px;
  --f7-block-title-margin-bottom: 2px;
  --f7-block-title-text-color: var(--ae-darkblue);
  // --f7-block-title-font-weight: 500;
  --f7-block-title-font-size: 14px;

  --search-title-color: var(--ae-darkblue);
  --search-input-height: 36px;
  --search-input-color: #848192;
  --search-input-font-size: 14px;
  --search-input-font-weight: 400;
  --search-btn-min-width: 40px;

  --popover-btn-color: var(--search-input-color);

  .content-searcher-erp {
    margin-bottom: 13px;
  }

  &__header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-bottom: 1px solid var(--his-silver);

    &--title {
      display: flex;
      justify-content: flex-start;
      color: var(--his-steel-blue);
      font-size: 14px;
      text-transform: uppercase;
      font-weight: 500;

      img {
        padding-right: 5px;
      }
    }

    &--buttons {
      height: 28px;
    }
  }

  &__buttons {
    display: flex;
    align-items: center;

    img {
      margin-right: 5px;
    }

    &--search {
      background-color: var(--his-oliva);
      color: #fff;
      width: 100%;
      height: 32px;
    }
  }
}

.container-filters__btn-ask {
  height: 24px;
  width: 22px;
  background-color: var(--his-disabled);
  color: var(--his-plum-haze);
}

.container-filters__btn-close {
  height: 24px;
  width: 22px;
  background: var(--his-oliva);
}

/* estilos acordeon */
.bloque-acordeon {
  padding: 0%;

  .items {
    background: var(--his-plum-haze);
  }
}

.storybook-action-sorted-accordion {
  .sorted-accordion {
    > .item-inner {
      background: var(--his-light-blue);
      color: var(--his-dark-blue);
    }
  }
}

.items_time {
  background: var(--his-light-blue);
  width: 45px;
  height: 22px;
  font-style: normal;
  font-weight: 500;
  font-size: 15px;
  line-height: 20px;
  margin-top: 6px;
  text-align: center;
  border-radius: 3px;
  color: var(--his-dark-blue);
}

.items_matricula {
  color: var(--his-oliva);
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 24px;
  padding-top: 10px;
}

.items_pallets {
  background: var(--his-mandarina);
  width: 45px;
  height: 22px;
  font-style: normal;
  font-weight: 500;
  border-radius: 3px;
  font-size: 15px;
  line-height: 20px;
  margin-top: 6px;
  text-align: center;
  color: #ba5333;
}

.items_article {
  font-style: normal;
  font-weight: 500;
  font-size: 19px;
  line-height: 20px;
  color: var(--his-dark-blue);
}

.items_info {
  color: var(--his-oliva);
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 24px;
}

.scan-code {
  z-index: 1;
  overflow-y: hidden;
  position: absolute;
  top: 45%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 65%;
  height: 37%;
  border-radius: 15px;
  box-shadow: 0 0 0 2000px rgb(0 0 0 / 40%);

  @media (max-width: 320px) {
    top: 50%;
  }

  @media (max-width: 360px) {
    top: 53%;
  }
}

.content-scan {
  background-color: #222;
}
</style>
